module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar2-plus-fill-0994a485.svg";